<template>
  <TemplateModal
    ref="modal"
    :edit="!create"
    :text="text"
    :send-function="onSave"
    :open-function="onOpen"
    :minimalize="minimalize"
  >
    <BaseInput
      :label="t['dialog-add_edit-labels']['nazvanie']"
      v-model="name"
      prepend-inner-icon="mdi-file-document-multiple"
    />
  </TemplateModal>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: 'WorkDocsDocumentTypeModal',
  props: {
    id: {
      type: [Number, String],
      default: 0,
    },
    create: Boolean,
    minimalize: Boolean,
  },
  data: () => ({
    name: ''
  }),
  computed: {
    t() {
      return this.localStorage.translations.pages['setting-document_type']
    },
    text() {
      return {
        button: {
          open: this.minimalize
            ? this.localStorage.translations.pages['common']['buttons']['dobavit']
            : this.t['dialog-add_edit-buttons']['dobavit-tip-dokumenta'],
        },
        title: {
          create: this.t['dialog-add_edit']['dobavlenie-tipa-dokumenta'],
          edit: this.t['dialog-add_edit']['redaktirovanie-tipa-dokumenta'],
        },
      }
    },
    SettingWorkDocsDocumentTypePage() {
      return this.$route.name === 'SettingWorkDocsDocumentType'
    },
  },
  watch: {
    workDocsDocumentTypeShow() {
      this.name = this.workDocsDocumentTypeShow.name
    },
  },
  methods: {
    ...mapActions('workDocsDocumentType', [
      'onWorkDocsDocumentTypeShow',
      'onWorkDocsDocumentTypeCreate',
      'onWorkDocsDocumentTypeGrid',
      'onWorkDocsDocumentTypeUpdate',
      'onWorkDocsDocumentTypeAll',
    ]),
    onOpen() {
      if (!this.create) {
        this.onWorkDocsDocumentTypeShow(this.id)
      }
    },
    onSave() {
      if (this.create) {
        let data = {
          name: this.name,
        }
        this.onWorkDocsDocumentTypeCreate(data)
          .then((response) => {
            if (response) {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message:
                    this.localStorage.translations.pages.common.notifications[
                      'uspeshno-dobavlen'
                      ],
                  IsError: false,
                },

                { root: true },
              )
              if (this.SettingWorkDocsDocumentTypePage) {
                this.onWorkDocsDocumentTypeGrid({
                  limit: this.$route.query.limit,
                  page: this.$route.query.page,
                })
              } else {
                this.onWorkDocsDocumentTypeAll()
              }

              this.closeModal()
            }
          })
          .catch((err) => {
            if (err.response.data.name[0]) {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message:
                    this.localStorage.translations.pages.common.notifications[
                      'name_is_already_in_use'
                      ],
                  IsError: true,
                },
                { root: true },
              )
            } else {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message: this.localStorage.translations.pages.common.notifications['oshibka'],
                  IsError: true,
                },
                { root: true },
              )
            }
          })
      } else {
        let data = {
          id: this.workDocsDocumentTypeShow.id,
          name: this.name,
        }
        this.onWorkDocsDocumentTypeUpdate(data)
          .then((response) => {
            if (response) {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message:
                    this.localStorage.translations.pages.common.notifications[
                      'izmeneniya-uspeshno-sohraneny'
                      ],
                  IsError: false,
                },

                { root: true },
              )
              this.onWorkDocsDocumentTypeGrid({
                limit: this.$route.query.limit,
                page: this.$route.query.page,
              })
              this.closeModal()
            }
          })
          .catch((err) => {
            if (err.response.data.name[0]) {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message:
                    this.localStorage.translations.pages.common.notifications[
                      'name_is_already_in_use'
                      ],
                  IsError: true,
                },
                { root: true },
              )
            } else {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message: this.localStorage.translations.pages.common.notifications['oshibka'],
                  IsError: true,
                },
                { root: true },
              )
            }
          })
      }
    },
  },
}
</script>
